/*--------------------------------------------------------------
# Custom scripts for Columns Slider block
--------------------------------------------------------------*/

// Check if columns-cards--3col exists before running any code
if (document.querySelector('.columns-cards--3col')) {
    const colCardsSlider = document.querySelectorAll('.columns-cards--3col .columns-cards-slider .swiper');
    const colCardsSliderPagination = document.querySelectorAll('.columns-cards--3col .columns-cards-swiper-pagination');
    const colCardsSliderNext = document.querySelectorAll('.columns-cards--3col .columns-cards-swiper-next');
    const colCardsSliderPrev = document.querySelectorAll('.columns-cards--3col .columns-cards-swiper-prev');

    for (let i = 0; i < colCardsSlider.length; i++) {
        // loop through every example of the slider and add a dynamic class
        // then init slider, pagination and nav arrows based on that new dynamic class
        colCardsSlider[i].classList.add('swiper-' + i);
        colCardsSliderPagination[i].classList.add('columns-cards-swiper-pagination-' + i);
        colCardsSliderNext[i].classList.add('columns-cards-swiper-next-' + i);
        colCardsSliderPrev[i].classList.add('columns-cards-swiper-prev-' + i);

        var initColCardsSlider = new Swiper('.columns-cards--3col .columns-cards-slider .swiper-' + i, {
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            // Pagination toggle buttons
            pagination: {
                el: '.columns-cards--3col .columns-cards-swiper-pagination-' + i,
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.columns-cards--3col .columns-cards-swiper-next-' + i,
                prevEl: '.columns-cards--3col .columns-cards-swiper-prev-' + i,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                748: {
                    slidesPerView: 2.05,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            }
        });
    }
}

// Check if columns-cards--2col exists before running any code
if (document.querySelector('.columns-cards--2col')) {
    const twoColCardsSlider = document.querySelectorAll('.columns-cards--2col .columns-cards-slider .swiper');
    const twoColCardsSliderPagination = document.querySelectorAll('.columns-cards--2col .columns-cards-swiper-pagination');
    const twoColCardsSliderNext = document.querySelectorAll('.columns-cards--2col .columns-cards-swiper-next');
    const twoColCardsSliderPrev = document.querySelectorAll('.columns-cards--2col .columns-cards-swiper-prev');

    for (let i = 0; i < twoColCardsSlider.length; i++) {
        // loop through every example of the slider and add a dynamic class
        // then init slider, pagination and nav arrows based on that new dynamic class
        twoColCardsSlider[i].classList.add('swiper-' + i);
        twoColCardsSliderPagination[i].classList.add('columns-cards-swiper-pagination-' + i);
        twoColCardsSliderNext[i].classList.add('columns-cards-swiper-next-' + i);
        twoColCardsSliderPrev[i].classList.add('columns-cards-swiper-prev-' + i);

        var inittwoColCardsSlider = new Swiper('.columns-cards--2col .columns-cards-slider .swiper-' + i, {
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            // Pagination toggle buttons
            pagination: {
                el: '.columns-cards--2col .columns-cards-swiper-pagination-' + i,
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.columns-cards--2col .columns-cards-swiper-next-' + i,
                prevEl: '.columns-cards--2col .columns-cards-swiper-prev-' + i,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                748: {
                    slidesPerView: 2.05,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                }
            }
        });
    }
}

// Check if columns-cards--4col exists before running any code
if (document.querySelector('.columns-cards--4col')) {
    const fourColCardsSlider = document.querySelectorAll('.columns-cards--4col .columns-cards-slider .swiper');
    const fourColCardsSliderPagination = document.querySelectorAll('.columns-cards--4col .columns-cards-swiper-pagination');
    const fourColCardsSliderNext = document.querySelectorAll('.columns-cards--4col .columns-cards-swiper-next');
    const fourColCardsSliderPrev = document.querySelectorAll('.columns-cards--4col .columns-cards-swiper-prev');

    for (let i = 0; i < fourColCardsSlider.length; i++) {
        // loop through every example of the slider and add a dynamic class
        // then init slider, pagination and nav arrows based on that new dynamic class
        fourColCardsSlider[i].classList.add('swiper-' + i);
        fourColCardsSliderPagination[i].classList.add('columns-cards-swiper-pagination-' + i);
        fourColCardsSliderNext[i].classList.add('columns-cards-swiper-next-' + i);
        fourColCardsSliderPrev[i].classList.add('columns-cards-swiper-prev-' + i);

        var initFourColCardsSlider = new Swiper('.columns-cards--4col .columns-cards-slider .swiper-' + i, {
            grabCursor: true,
            slidesPerView: 1,
            spaceBetween: 24,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            // Pagination toggle buttons
            pagination: {
                el: '.columns-cards--4col .columns-cards-swiper-pagination-' + i,
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.columns-cards--4col .columns-cards-swiper-next-' + i,
                prevEl: '.columns-cards--4col .columns-cards-swiper-prev-' + i,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                748: {
                    slidesPerView: 2.05,
                    slidesPerGroup: 2,
                },
                992: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            }
        });
    }
}
